import React from "react";
import Modal from "react-modal";

import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { setShowAddInvoiceModal } from "../../ordersSlice";
import { InvoiceType } from "../../../../models";
import { WeightOverageInvoiceForm, CustomInvoiceForm } from "../../components";

import { ReactComponent as Close } from "../../../../assets/images/close.svg";
import "./AddInvoiceModal.scss";

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#FFFFFF",
  },
  overlay: {
    backgroundColor: "rgba(255, 255, 255, 0.9)",
  },
};

export const AddInvoiceModal: React.FC = () => {
  const dispatch = useAppDispatch();

  const [invoiceType, setInvoiceType] = React.useState<InvoiceType>(
    InvoiceType.WEIGHT_OVERAGE
  );

  const showAddInvoiceModal = useAppSelector(
    (state) => state.orders.showAddInvoiceModal
  );

  const isOpen = !!showAddInvoiceModal;

  const onClose = () => {
    dispatch(setShowAddInvoiceModal(undefined));
  };

  const renderInvoiceTypeTabs = () => {
    return (
      <div className="invoice-type-tabs">
        <div
          className={`tab ${
            invoiceType === InvoiceType.WEIGHT_OVERAGE ? "active" : ""
          }`}
          onClick={() => setInvoiceType(InvoiceType.WEIGHT_OVERAGE)}
        >
          Weight Overages
        </div>
        <div
          className={`tab ${
            invoiceType === InvoiceType.CUSTOM ? "active" : ""
          }`}
          onClick={() => setInvoiceType(InvoiceType.CUSTOM)}
        >
          Custom
        </div>
      </div>
    );
  };

  return (
    <Modal isOpen={isOpen} onRequestClose={onClose} style={modalStyles}>
      <div className="add-invoice-modal-component">
        <div className="header-container">
          <div className="header-title">Add Invoice</div>

          <div className="close-container">
            <Close className="close-button" onClick={onClose} />
          </div>
        </div>

        {renderInvoiceTypeTabs()}

        {isOpen && invoiceType === InvoiceType.WEIGHT_OVERAGE && (
          <WeightOverageInvoiceForm order={showAddInvoiceModal} />
        )}
        {isOpen && invoiceType === InvoiceType.CUSTOM && (
          <CustomInvoiceForm order={showAddInvoiceModal} />
        )}
      </div>
    </Modal>
  );
};
